import { getAtomsCatcherMittColorCells } from 'src/features/brands/atoms/simulationSpecification'
import { getDxMCatcherMittColorCells } from 'src/features/brands/dxm/simulationSpecification'
import { getGorillaCatcherMittColorCells } from 'src/features/brands/gorilla/simulationSpecification'
import { getRagDeLionCatcherMittColorCells } from 'src/features/brands/ragdelion/simulatedSpecification'
import { Brand, I18NText, State } from 'src/types'

export const genCatcherMittColorCells = (state: State, brand: Brand, t: I18NText) => {
  switch (brand) {
    case 'atoms':
      return getAtomsCatcherMittColorCells(state, t)
    case 'ragdelion':
      return getRagDeLionCatcherMittColorCells(state, t)
    case 'dxm':
      return getDxMCatcherMittColorCells(state, t)
    case 'gorilla':
      return getGorillaCatcherMittColorCells(state, t)
    // case 'treasure':
    //   return [
    //     ...commonCatcherMittColorCells,
    //     genCatcherMittColorCell('親指マチ', state.thumbMachi, 'thumbMachi'),
    //     genCatcherMittColorCell('小指マチ', state.littleMachi, 'littleMachi'),
    //     genCatcherMittColorCell('ハミダシ', state.hamidashi, 'hamidashi'),
    //     ...variableParts,
    //     isTreasureEmblem && genCatcherMittColorCell('Treasureエンブレム', state.treasureOriginalParts, 'treasureOriginalParts'),
    //     genCatcherMittColorCell('Treasureラベル(メイン)', state.treasureLabelMain, 'treasureLabelMain'),
    //     genCatcherMittColorCell('Treasureラベル(影)', state.treasureLabelShadow, 'treasureLabelShadow'),
    //     genCatcherMittColorCell('Treasureラベル(台)', state.treasureLabelStand, 'treasureLabelStand')
    //   ].filter(Boolean)
  }
}
